import { render, staticRenderFns } from "./Copytaxreturns.vue?vue&type=template&id=58515057&scoped=true&"
import script from "./Copytaxreturns.vue?vue&type=script&lang=js&"
export * from "./Copytaxreturns.vue?vue&type=script&lang=js&"
import style0 from "./Copytaxreturns.vue?vue&type=style&index=0&id=58515057&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58515057",
  null
  
)

export default component.exports